/**
 * Keeps a SAVED launcher-category config (Catalog > Configuration) in step
 * with sections added in code later.
 *
 * The saved value replaces the code default wholesale, so a section added in
 * code after an admin saved (Analytics, 2026-09-27) was missing from the list,
 * and every module whose built-in category pointed at it fell into the
 * catch-all "More" section. Missing default sections are now slotted in ahead
 * of Tools, which stays last. An empty section still renders nothing, so this
 * only shows up where a module actually lands in it.
 */

import type { LauncherCategoriesValue } from './types';

export function withNewDefaultCategories(
  saved: LauncherCategoriesValue,
  defaults: LauncherCategoriesValue
): LauncherCategoriesValue {
  const have = new Set(saved.categories.map((c) => c.id));
  const missing = defaults.categories.filter((c) => !have.has(c.id));
  if (missing.length === 0) return saved;
  const categories = [...saved.categories];
  const tools = categories.findIndex((c) => c.id === 'tools');
  categories.splice(tools < 0 ? categories.length : tools, 0, ...missing);
  return { ...saved, categories };
}
